import {remCalc} from '../_utils'

const spacing = {
    xxsmall: {
        base: remCalc(4),
        sm: remCalc(4),
        md: remCalc(8),
        lg: remCalc(8),
    },
    xsmall: {
        base: remCalc(8),
        sm: remCalc(8),
        md: remCalc(16),
        lg: remCalc(16),
    },
    small: {
        base: remCalc(16),
        sm: remCalc(16),
        md: remCalc(24),
        lg: remCalc(24),
    },
    medium: {
        base: remCalc(24),
        sm: remCalc(24),
        md: remCalc(40),
        lg: remCalc(40),
    },
    large: {
        base: remCalc(40),
        sm: remCalc(40),
        md: remCalc(80),
        lg: remCalc(80),
    },
    xlarge: {
        base: remCalc(80),
        sm: remCalc(80),
        md: remCalc(160),
        lg: remCalc(160),
    },
}

export default spacing
